(function () {
'use strict';

angular
    .module('aricCertificationRoutes', [
        'aricCertificationModule'
    ])
    .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {
        $stateProvider
             .state('aricCertification', {
                 url: '/Aric/Certification',
                 resolve: {
                     activeProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveARIC();
                     }]
                 },
                 views: {
                     '': {
                         templateUrl: require('./certification.tpl.html'),
                         controller: 'AricCertificationController',
                     }
                 }
             })

            .state('aricCertification.noActiveProcess', {
                url: '/NoActiveProcess',
                views: {
                    'mainContent@aricCertification': {
                        templateUrl: require('./withNoActiveProcess.tpl.html'),
                    }
                }
            })

            .state('aricCertification.user', {
                url: '/User@{ItemPersonID:int}',
                resolve: {
                    aricControls: ['$stateParams', 'commonAricService', function ($stateParams, service) {
                        return service.getControlsToCertifyByOwner($stateParams.ItemPersonID).then(function(aricControls) {
                            return _.map(aricControls, function(aricControl) {
                                aricControl.ControlAssessment = aricControl.Assessment;
                                delete aricControl.Assessment;
                                return aricControl;
                            });
                        });
                    }],
                    controlOwnerAssessment: ['$stateParams', 'commonAricService', function ($stateParams, service) {
                        return service.getControlOwnerAssessmentByOwnerID($stateParams.ItemPersonID).then(function (controlOwnerAssessment) {
                            return controlOwnerAssessment;
                        });
                    }],
                    ownerAssessmentTypes: function () {
                        return ['Responsibility'];
                    }
                },
                views: {
                    'mainContent@aricCertification': {
                        controller: 'AricOwnerCertificationController',
                    }
                }
            })

            .state('aricCertification.user.control', {
                url: '/Control/{ControlID:int}',
                views: {
                    'mainContent@aricCertification': {
                        controller: 'AricControlCertificationController',
                        templateUrl: require('./controlCertification.tpl.html'),
                        resolve: {
                            aricControl: ['$stateParams', 'aricControls', function ($stateParams, aricControls) {
                                return _.find(aricControls, { ControlID: $stateParams.ControlID });
                            }]
                        },
                    }
                }
            })

            .state('aricCertification.user.welcome', {
                url: '/Welcome',
                views: {
                    'mainContent@aricCertification': {
                        controller: 'AricOwnerCertificationWelcomeController',
                        templateUrl: require('./welcome.tpl.html'),
                    }
                }
            })

            .state('aricCertification.user.completed', {
                url: '/Completed',
                views: {
                    'mainContent@aricCertification': {
                        templateUrl: require('./completed.tpl.html'),
                    }
                }
            })

            .state('aricCertification.user.assessment', {
                url: '/{OwnerAssessmentType:string}',
                views: {
                    'mainContent@aricCertification': {
                        controller: 'OwnerAssessmentController',
                        templateUrl: require('./OwnerAssessment.tpl.html')
                    }
                }
            });

        //historyCtxtServiceProvider.setCtxtState('aricControlOwnerList.byOwner',
        //    '/app/Main/aric/GOVHistoryCtxtDirective-aricControlOwner.tpl.html'
        //);
    }
})();
